import React, { Fragment, useContext, useState, useEffect } from "react";
import parse from "html-react-parser";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Link } from "react-router-dom";
import cx from "classnames";

import _API from "@util/api";
import _CK from "@util/cookie";
import _U from "@util/utilities";

import { AppContext } from "@component/AppProvider";

export default () => {
    const { site, saveIam } = useContext(AppContext);
    const navigate = useNavigate();

    const [data, setData] = useState(null);
    const [notice, setNotice] = useState([]);

    const onLogin = () => {
        _API.get({ path: "/site/member/login", data })
            .then((res) => {
                const { accessKey, iam } = res.data;
                _CK.setAuth(accessKey);
                saveIam(iam);
            })
            .catch((e) => {
                _API.alert({ message: e.message });
            });
    };

    const onLogout = (e) => {
        e.preventDefault();

        saveIam(null);
        _CK.clearAuth();
        //document.location.href = "/";
    };

    const getMain = (type) => {
        const main = site?.main?.find((m) => m.mainPosition === type);
        if (!main || !main?.content) return "";
        return parse(main?.content);
    };

    const loadNotice = () => {
        _API.get({ path: "/site/bbs", data: { code: "notice", limit: 7 } })
            .then((res) => {
                const { list } = res.data;
                setNotice(list);
            })
            .catch((e) => {
                _API.alert({ message: e.message });
            });
    };

    useEffect(() => {
        if (site.siteCode) {
            loadNotice();
        }
    }, [site]);

    return (
        <Fragment>
            {getMain("TOP")}

            <div className="mainBoard">
                <div className="inner">
                    {site?.isMainNotice === "Y" && (
                        <div className="box_board type--img">
                            <div className="cont">
                                <p className="main_notice_title">
                                    <strong>NOTICE</strong>
                                </p>

                                <Link to={"/bbs/notice"} className="btn_more">
                                    <img src="/assets/images/ico_more.png" alt="more" />
                                </Link>

                                <ul className="main_notice">
                                    {notice?.map((item, index) => (
                                        <li key={index}>
                                            <Link to={`/bbs/notice/${item.idx}`}>
                                                {moment(item.regDate).add(7, "days") > moment() && <img src="/assets/images/ico_new.png" alt="new" className="new" />}
                                                <div className="tit">{item.title} </div>
                                                <div className="date">{moment(item.regDate).format("YYYY-MM-DD")}</div>
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    )}
                    <div className="box_board type--login">
                        <div className="cont">
                            {site?.eventDate && (
                                <div className="dDay">
                                    <span>Today {moment().format("YYYY.MM.DD")}</span>
                                    <strong>
                                        D-DAY
                                        {_U.getDday(site?.eventDate)}
                                    </strong>
                                </div>
                            )}

                            {_CK.isLogin() ? (
                                <div className="after_login">
                                    <p>
                                        <span className="main_after_login">Welcome to {site?.title} website</span>
                                    </p>
                                    <a href="/mypage" className="btn1 btn_border1">
                                        My page
                                    </a>
                                    &nbsp;
                                    <button className="btn1 btn_border1" onClick={onLogout}>
                                        Logout
                                    </button>
                                </div>
                            ) : (
                                <div className="login">
                                    <p>
                                        <strong>
                                            <img src="/assets/images/ico_login.png" alt="" />
                                            LOGIN
                                        </strong>
                                        <span>Please log-in with your ID (E-mail) and Password if you are already signed up as a user.</span>
                                    </p>
                                    <div className="inputBox">
                                        <span>
                                            <label for="id">ID (E-mail)</label>
                                            <input type="text" id="id" name="id" value={data?.id} onChange={(e) => setData({ ...data, [e.target.name]: e.target.value })} />
                                        </span>
                                        <span>
                                            <label for="password">Password</label>
                                            <input type="password" id="password" name="passwd" value={data?.passwd} onChange={(e) => setData({ ...data, [e.target.name]: e.target.value })} />
                                        </span>
                                        <button type="button" onClick={onLogin}>
                                            LOGIN
                                        </button>
                                    </div>
                                    <a href="/join/find" className="btn1 btn_border1">
                                        Find Password
                                    </a>
                                    &nbsp;
                                    <a href="/join" className="btn1 btn_border1">
                                        Create Account
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {getMain("BOTTOM")}
        </Fragment>
    );
};
